var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-main"},[_vm._m(0),_c('div',{staticClass:"contact-content",domProps:{"innerHTML":_vm._s(_vm.contactText)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-title"},[_c('div',{staticClass:"contact-title-span"},[_vm._v("联系我们")])])
}]

export { render, staticRenderFns }